// extracted by mini-css-extract-plugin
module.exports = {"new-password":"PasswordNew_new-password__h5gZa"};